module.exports = new __parcel__URL__("machines_plasma_mortar_level_1.576bd2eb.png").toString();